export default "__VITE_ASSET__CLsVRxTX__"